<app-loader></app-loader>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<form class="basic-information" [formGroup]="driverUpdateForm">
    <div class="basic-tabs" [ngClass]="{'basic-tab-edit': showInput}">
        <div class="grid" [class.showedit]="showInput">
            <div class="col-12 md:col-4" [ngClass]="{'col-12 md:col-3': showInput}">
                <div class="driver-info">
                    <div class="upload-icon"><img [src]="(imageUrl ? imageUrl: dummy)" alt="" />

                        <div *ngIf="showInput && !imageUrl">
                            <img class="upload-img" id="profileImage" src="../../../../../assets/images/driver-edit.svg"
                                alt="Profile" (click)="triggerFileInput()" />
                            <input type="file" id="fileInput" style="display: none;" (change)="onImageSelected($event)">
                        </div>
                        <div *ngIf="showInput && imageUrl">
                            <img class="upload-img" i src="../../../../../assets/images/circle-delete.svg" alt="Profile"
                                (click)="clearImage()" />
                        </div>

                    </div>
                    <div class="common-text">
                        <p><strong [ngClass]="{'normal-name': !showInput}">{{showInput ? 'First Name': 'Name'}}<span
                                    *ngIf="showInput" class="astrik-star">*</span> -
                            </strong> <span *ngIf="!showInput" class="text-outer">{{driverDetails?.name}}</span><span
                                class="input-outer">
                                <input *ngIf="showInput" type="text" NoLeadingSpaceDirective
                                    placeholder="Enter First Name" pInputText formControlName="firstName" maxlength="50"
                                    (keydown)="dialogControlService.noNumbersValidator($event)" />

                                <div class="error-outer mobile-error"
                                    *ngIf="driverUpdateForm.get('firstName')?.dirty || driverUpdateForm.get('firstName')?.touched">
                                    <div *ngIf="driverUpdateForm.get('firstName')?.hasError('required')">
                                        <small class="validation-error">This field is required*</small>
                                    </div>
                                    <div
                                        *ngIf="!driverUpdateForm.get('firstName')?.hasError('required') && driverUpdateForm.get('firstName')?.hasError('leadingSpace')">
                                        <small class="validation-error">First Name cannot start with a space.*</small>
                                    </div>
                                    <div
                                        *ngIf="!driverUpdateForm.get('firstName')?.hasError('required') && !driverUpdateForm.get('firstName')?.hasError('leadingSpace') && driverUpdateForm.get('firstName')?.hasError('minlength')">
                                        <small class="validation-error">Minimum 3 letters are required*</small>
                                    </div>
                                    <div
                                        *ngIf="!driverUpdateForm.get('firstName')?.hasError('required') && !driverUpdateForm.get('firstName')?.hasError('leadingSpace') && !driverUpdateForm.get('firstName')?.hasError('minlength') && driverUpdateForm.get('firstName')?.hasError('pattern')">
                                        <small class="validation-error">Please enter only characters*</small>
                                    </div>
                                </div>

                            </span>
                        </p>
                        <p *ngIf="!showInput" class="edit-email"><strong [ngClass]="{'normal-name': !showInput}">Email -
                            </strong><span>{{driverDetails?.email}}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-12 md:col-3" *ngIf="showInput">
                <div class="driver-info">
                    <div class="common-text">
                        <p><strong>Last Name <span *ngIf="requiredLastNameAsterisk" class="astrik-star">*</span>- </strong> <span
                                *ngIf="!showInput" class="text-outer">{{driverDetails?.name}}</span><span
                                class="input-outer">
                                <input *ngIf="showInput" type="text" placeholder="Enter Last name" pInputText
                                    formControlName="lastName" maxlength="50"
                                    (keydown)="dialogControlService.noNumbersValidator($event)" />

                                <div class="error-outer mobile-error"
                                    *ngIf="driverUpdateForm.get('lastName')?.dirty || driverUpdateForm.get('lastName')?.touched">
                                    <div *ngIf="driverUpdateForm.get('lastName')?.hasError('required')">
                                        <small class="validation-error">This field is required*</small>
                                    </div>
                                    <div
                                        *ngIf="!driverUpdateForm.get('lastName')?.hasError('required') && driverUpdateForm.get('lastName')?.hasError('leadingSpace')">
                                        <small class="validation-error">Last Name cannot start with a space.*</small>
                                    </div>
                                    <div
                                        *ngIf="!driverUpdateForm.get('lastName')?.hasError('required') && !driverUpdateForm.get('lastName')?.hasError('leadingSpace') && driverUpdateForm.get('lastName')?.hasError('minlength')">
                                        <small class="validation-error">Minimum 3 letters are required*</small>
                                    </div>
                                    <div
                                        *ngIf="!driverUpdateForm.get('lastName')?.hasError('required') && !driverUpdateForm.get('lastName')?.hasError('leadingSpace') && !driverUpdateForm.get('lastName')?.hasError('minlength') && driverUpdateForm.get('lastName')?.hasError('pattern')">
                                        <small class="validation-error">Please enter only characters*</small>
                                    </div>
                                </div>
                            </span></p>
                    </div>
                </div>
            </div>
            <div class="col-12 md:col-3">
                <div class="driver-info" [ngClass]="{'driver-info-edit': showInput}">

                    <div class="common-text">
                        <p><strong>Mobile Number <span *ngIf="showInput" class="astrik-star">*</span>-</strong>
                            <span class="text-outer country-code" *ngIf="!showInput && driverDetails?.mobileNumber">
                                <img class="flag-outer" [ngClass]="getFlagClass(driverDetails?.iso)" alt="" /><span
                                    class="country-code">{{driverDetails?.countryCode}}
                                    {{driverDetails?.mobileNumber}}</span></span>

                            <span class="input-outer">
                                <div *ngIf="showInput" class="number-text">
                                    <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="preferredCountries"
                                        [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                                        [searchCountryFlag]="true" customPlaceholder="Enter Mobile Number"
                                        [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]"
                                        [selectFirstCountry]="false" [selectedCountryISO]="countryISO" [maxLength]="10"
                                        [phoneValidation]="true" [separateDialCode]="separateDialCode"
                                        [numberFormat]="phoneNumberFormat.National" name="phone"
                                        formControlName="phone">
                                    </ngx-intl-tel-input>
                                </div>
                                <div class="error-outer mobile-error">
                                    <div
                                        *ngIf="driverUpdateForm.get('phone').hasError('required') && driverUpdateForm.get('phone').dirty && driverUpdateForm.get('phone').touched">
                                        <small class="validation-error">This field is required*</small>
                                    </div>
                                    <div
                                        *ngIf="!driverUpdateForm.get('phone').hasError('required') && driverUpdateForm.get('phone').touched && driverUpdateForm.get('phone').invalid">
                                        <small class="validation-error">Mobile number is not valid*</small>
                                    </div>
                                </div>
                            </span>
                        </p>
                        <p *ngIf="!showInput" class="edit-email visible-hide">&nbsp</p>
                    </div>

                </div>
            </div>
            <div class="col-12 md:col-3" *ngIf="showInput">
                <div class="driver-info">
                    <div class="common-text">
                        <p><strong>Email <span *ngIf="showInput" class="astrik-star">*</span>- </strong> <span *ngIf="!showInput"
                                class="text-outer">{{driverDetails?.email}}</span><span class="input-outer">
                                <input *ngIf="showInput" type="text" placeholder="Enter Email" pInputText
                                    formControlName="email" maxlength="50" />

                                <div class="error-outer mobile-error">
                                    <div
                                        *ngIf="driverUpdateForm.get('email')?.hasError('required') && (driverUpdateForm.get('email')?.dirty || driverUpdateForm.get('email')?.touched)">
                                        <div class="validation-error">This Field is required*</div>
                                    </div>
                                    <div
                                        *ngIf="driverUpdateForm.get('email')?.hasError('pattern') && (driverUpdateForm.get('email')?.dirty || driverUpdateForm.get('email')?.touched)">
                                        <div class="validation-error">Email is not valid*</div>
                                    </div>
                                </div>
                            </span></p>
                    </div>

                </div>
            </div>
            <div *ngIf="!showInput" class="col-12 md:col-3">
                <div class="driver-info">
                    <div class="common-text">
                        <p><strong>Profile Created By -
                            </strong><span>{{driverDetails?.profileCreatedBy}}</span></p>
                        <p><strong>Profile Created On -
                            </strong><span>{{driverDetails?.profileCreated}}</span></p>
                    </div>
                </div>
            </div>
            <div *ngIf="!showInput" class="col-12 md:col-2">
                <div class="driver-info">
                    <div class="common-text credit-outer">
                        <p><strong>Credit</strong> <span class="custom-points">{{driverDetails?.credit}} Points</span>
                            <app-tooltip *ngIf='role === userRoles.SUPER_ADMIN' [tooltipMessage]="tooltipTableTemplate"
                                [addClass]="'dues-tooltip-outer'"></app-tooltip>
                        </p>
                        <p><strong>Dues</strong> <span class="due-text">${{driverDetails?.bookingDueCharges}}</span>

                        </p>
                    </div>
                </div>
            </div>

            <div *ngIf="showInput" class="col-12 md:col-12">
                <div class="save-outer custom-tabs">
                    <p-button styleClass="p-button search-button" class="mr-3" (onClick)="updateDriverInformation()"
                        label="Update" type="submit"></p-button>
                    <span class="secorday-outer">
                        <p-button class="secondary-btn custom-secondary" styleClass="search-button"
                            (onClick)="calcelDriverInfoEdit(driverDetails)" label="Cancel"
                            type="submit"></p-button></span>

                </div>
            </div>
        </div>
    </div>
</form>
<ng-template #tooltipTableTemplate>
  <div class="dues-table">
    <!-- Check if userCredits exist -->
    <ng-container *ngIf="driverDetails?.userCredits?.length > 0; else noCredits">

      <!-- Check if there are any valid credits -->
      <ng-container *ngIf="hasValidCredits(); else noCredits">
        <div class="dues-heading">
          <h5>Company Name</h5>
          <h5>Credits</h5>
        </div>

        <!-- List each credit with amount > 0 -->
        <div *ngFor="let credit of driverDetails.userCredits">
          <ng-container *ngIf="credit.amount > 0">
            <div class="table-body">
              <p>{{ credit.companyName }}</p>
              <p>{{ credit.amount }}</p>
            </div>
          </ng-container>
        </div>
      </ng-container>

    </ng-container>

    <ng-template #noCredits>
      <div class="table-body"><p>No credits yet</p></div>
    </ng-template>
  </div>
</ng-template>
